import { useState, useEffect } from "react";
import { getCabins } from "@/lib/api";
import useLenis from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Cabins } from "@/components/site/Cabins";
import { Reservation } from "@/components/site/Reservation";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  useLenis();
  const [cabins, setCabins] = useState([]);
  const [selectedId, setSelectedId] = useState("araucaria");

  useEffect(() => {
    getCabins().then(setCabins).catch(() => setCabins([]));
  }, []);

  const handleReserve = (id) => {
    setSelectedId(id);
    const el = document.querySelector("#reservar");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="grain-overlay relative bg-brand-cream min-h-screen">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      {cabins.length > 0 && (
        <>
          <div id="galeria">
            <Cabins cabins={cabins} onReserve={handleReserve} />
          </div>
          <Reservation cabins={cabins} selectedId={selectedId} setSelectedId={setSelectedId} />
        </>
      )}
      <Footer />
    </div>
  );
}
